import { useState } from 'react';
import { useAsyncEffect } from './useAsyncEffect';
import { useClient } from '../context/client';

export function useOrderStatuses() {
	const [orderStatuses, setOrderStatuses] = useState([]);
	const client = useClient();

	useAsyncEffect(async () => {
		setOrderStatuses(await client.getOrderStatuses());
	});

	return orderStatuses;
}
